import { useApiClient } from '../client'

export const GET_WEB_BASED_SUBSCRIPTION_ASSIGNMENT_ENDPOINT = '/core/v2/business_api/me/businesses/{business_pk}/billing/web_based_subscription/assignment/'

export const WEB_BASED_SUBSCRIPTION_ALLOCATIONS = {
  CONTROL: 'control',
  VARIANT_A: 'variant_A',
} as const

export type WebBasedSubscriptionAllocation = ValueOf<typeof WEB_BASED_SUBSCRIPTION_ALLOCATIONS>

export type WebBasedSubscriptionAssignmentResponse = {
  allocation: WebBasedSubscriptionAllocation
}

export function getExperimentWebBasedSubscriptionEnabled (businessId: number | string) {
  const apiClient = useApiClient()

  return apiClient.get<WebBasedSubscriptionAssignmentResponse>({
    url: GET_WEB_BASED_SUBSCRIPTION_ASSIGNMENT_ENDPOINT,
    urlParams: {
      business_pk: businessId,
    },
  })
}
